import {gql} from "@apollo/client";

export const GET_RANDOM_MORTGAGE_RESEARCH = gql`
    query {
        person {
            firstName
            lastName
            email
            phone
            phone2
            phone3
            creditProfile
            isVeteran
        }
        property {
            value
            type
            used
            location {
                state
                city
                zip
                street
            }
            loan {
                purpose
                amount
                program
            }
        }
    }
`;